import theme from '~lib/styles/Theme';

export const PIE_CHART_LABELS_INFO = [
  {
    label: '없음',
    backgroundColor: theme.colors.greynavy100,
  },
  {
    label: '가끔',
    backgroundColor: theme.colors.greynavy300,
  },
  {
    label: '매번',
    backgroundColor: '#363F84',
  },
];
